<template>
    <div class="div">
        <button v-if="isAdmin || isSupplier" class="button is-small" :class="{'bold' : isFilled}" @click="openModal" style="min-width: 55px;">
            {{ carData.query.inland_company }}
        </button>
        <button v-else class="button is-small" :class="{'bold' : isFilled}" style="min-width: 55px;">
            {{ carData.query.inland_company }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Inland Company: {{ carData.query.inland_company }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                            <tr>
                                <th width="10">Select</th>
                                <th>Name</th>
                                <th>Info</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(company, index) in companies">
                                <td width="10">
                                    <button class="button is-info" @click="selectCompany(company.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                    </button>
                                </td>
                                <td class="subtitle">{{ company.name }}</td>
                                <td>{{ company.info }}</td>
                                <td width="10">
                                    <button class="button is-danger" @click="deleteCompany(index, company)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <input v-model="newCompany.name" class="input" type="text" placeholder="Type name of the company">
                                </td>
                                <td>
                                    <input v-model="newCompany.info" class="input" type="text" placeholder="Type company info">
                                </td>
                                <td width="10">
                                    <button class="button is-primary" @click="createNewCompany">
                                        <span class="icon">
                                              <i class="fas fa-save"></i>
                                            </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInlandCompanies from './../../../api/apiInlandCompanies'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                companies: [],
                carData:{
                    id: this.car.id,
                    query: {
                        inland_company: this.car.inland_company === null ? '---' : this.car.inland_company,
                    }
                },
                newCompany: {
                    name: '',
                    info: ''
                }
            }
        },
        methods: {
            createNewCompany(){
                apiInlandCompanies
                    .createInlandCompanyRequest(this.newCompany)
                    .then((response) => {
                        this.companies.push(response.data)
                        this.newCompany.name = ''
                        this.newCompany.info = ''
                    })
                    .catch(error => console.log(error))
            },
            selectCompany(name) {
                this.carData.query.inland_company = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            deleteCompany(index, port){
                apiInlandCompanies
                    .deleteInlandCompanyRequest(port.id)
                    .then((response) => {
                        this.companies = this.companies.filter(item => item !== port)
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                apiInlandCompanies
                    .inlandCompaniesListRequest()
                    .then((response) => {
                        this.companies = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.inland_company !== '---'){
                    return  true;
                }
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSupplier() {
                if (this.$store.getters.getUserRole === 'Supplier') {
                    return true
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .bold {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/InlandCompanyColumn.vue